<template>
  <section>
    <div class="title-container mb-4">
      <h3 class="title">
        Users
      </h3>
    </div>

    <div class="d-flex">
      <div class="user-sidebar">
        <b-nav
          class="user-nav"
          v-b-scrollspy:nav-scroller
        >
          <b-nav-item
            class="user-nav-link"
            v-for="(roleUsers, role) in users"
            :href="'#'+ role"
            :key="role"
          >
            {{ getRole(role.toLowerCase()) }}
          </b-nav-item>
        </b-nav>
      </div>

      <b-container fluid class="card__list">
        <b-row v-for="(roleUsers, role) in users" :key="role">
          <div class="col-12">
            <div
              v-if="role !== ''" class="role"
              :id="role"
            >
              <div class="role__text">
                {{ getRole(role.toLowerCase()) }}
              </div>
            </div>
          </div>
          <template v-for="(user, index) in roleUsers">
            <div
              v-if="role && user.jira_user_name"
              :key="index"
              class="col-4 card__item"
            >
              <div class="card-user">
                <img class="img card-user__img" :src="user.avatar" :alt="user.name" />
                <div class="card-text">
                  <div class="card-user__title">{{user.name}}</div>
                  <template v-if="user.position !== ''">
                    <div class="card-user__position">
                      {{user.position}}
                    </div>
                  </template>
                  <template v-else>
                    <div class="card-user__position">
                      {{user.roles[0].name}}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </b-row>
      </b-container>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Users',
  data () {
    return {
      users: {
        administrator: [],
        unit_manager: [],
        developer: [],
        business_developer: [],
        designer: [],
        qa: []
      },
      ajaxLoader: true
    }
  },
  mounted () {
    this.axios({
      method: 'get',
      url: '/api/users-with-roles',
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    })
      .then(response => {
        const keys = Object.keys(response.data)
        keys.forEach(k => {
          this.users[k] = response.data[k]
        })
        // this.users = response.data
        this.ajaxLoader = false
      })
      .catch(err => {
        console.log(err)
      })
  },
  created () {
    this.setScrollerBodyAttribute()
  },
  beforeDestroy () {
    this.removeScrollerBodyAttribute()
  },
  methods: {
    setScrollerBodyAttribute () {
      document.body.setAttribute('id', 'nav-scroller')
    },
    removeScrollerBodyAttribute () {
      document.body.removeAttribute('id', 'nav-scroller')
    },
    getRole (role) {
      return {
        'administrator': 'Founders',
        'unit_manager': 'Unit managers',
        'project_manager': 'Project Managers',
        'business_analyst': 'Business analysts',
        'business_developer': 'Business developers',
        'account_manager': 'Account managers',
        'designer': 'Designers',
        'recruiter': 'Recruiters',
        'hr': 'HR',
        'developer': 'Developers',
        'qa': 'QA'
      }[role]
    }
  }
}
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Lato&display=swap");

.home-icon {
  position: relative;
  left: 16px;
  top: 23%;
}

.link-to-home {
  background-color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  position: fixed;
  z-index: 150;
  left: 20px;
  bottom: 10px;
}

.ajaxLoader {
  margin: 0 auto;
  position: relative;
  margin-top: 37%;
  width: 100%;
}

.notActiveAjax {
  display: none;
}

.img {
  width: 310px;
}

.card-user {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  text-align: center;
}
.card-user__img{
  width: 130px;
  height: 130px;
  border-radius: 100%;
  margin-bottom: 10px;
}
.card-user__title{
  font-family: $font-family-sans-serif;
  font-weight: 500;
  font-size: 22px;
  line-height: 24px;
  color: $fontColorBase;
  height: 48px;
  overflow: hidden;
}
.card-user__position{
  font-family: $font-family-sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: $fontColor3;
  margin-top: 5px;
  height: 48px;
  overflow: hidden;
}
.card__item{
  margin-bottom: 30px;
}

.user-wrapper {
  display: flex;
  justify-content: center;
}

.role {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: $font-family-sans-serif;
  color: $fontColor2;
  font-size: 24px;
  font-weight: 500;
  position: relative;
  margin-bottom: 30px;
  &:after{
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #CACEDB;
  }
}
.role__text{
  background-color: $bgColorBase;
  padding: 0 10px;
  position: relative;
  z-index: 1;
}

  .user-sidebar{
    display: block;
    min-width: 250px;
  }

.user-nav-link{
  border-left: 2px solid #CDD5DD;
  &:hover,
  &:focus,
  &.active{
    border-color: $fontColorBase;
    a{
      color: $fontColorBase;
    }

  }
  a{
    font-family: $font-family-second;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: $fontColor3;
    padding: 10px 20px;

  }
}
.user-nav{
  flex-direction: column;
  position: sticky;
  top: 20px;
}

</style>
